<span class="tooltip-trigger"
      (mouseenter)="show = true"
      (mouseleave)="show = false"
      (focusin)="show = true"
      (focusout)="show = false"
      tabindex="0">
  <ng-content></ng-content>
  <div class="tooltip-content" *ngIf="show" [ngClass]="position" [style.width]="width">
    <span class="tooltip-arrow" [ngClass]="position"></span>
    {{ tooltip }}
  </div>
</span>
